import React from "react";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";

const containerStyle = {
  width: "100%",
  height: "400px",
};

interface CustomGoogleMapProps {
  markerPosition: { lat: number; lng: number };
  markerTitle?: string;
}

const CustomGoogleMap: React.FC<CustomGoogleMapProps> = ({ markerPosition, markerTitle }) => {
  const mapId = '6303fd24d624ac1d';

  return (
    <APIProvider apiKey="AIzaSyDAYEvN_dtqip3-kVILYCqxGJ49BuRFLGE">
      <Map
        style={containerStyle}
        defaultCenter={markerPosition}
        defaultZoom={17}
		mapId={mapId}
		mapTypeControl={false} // Hides map/satellite toggle
		streetViewControl={false} // Hides Pegman (Street View)
      >
        <AdvancedMarker
			position={markerPosition}
			title={markerTitle}
		/>
      </Map>
    </APIProvider>
  );
};

export default CustomGoogleMap;
